"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = concatMiddleware;

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function concatMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (options) {
    var setup = middlewares.reduce(function (setup, middleware) {
      return middleware ? [].concat(_toConsumableArray(setup), [middleware(options)]) : setup;
    }, []);
    return function (last) {
      var stack = setup.slice();

      var work = function work() {
        var next = stack.shift();
        return (next ? next(work) : last).apply(void 0, arguments);
      };

      return work;
    };
  };
}